import React, { useCallback, useState } from 'react';
import { CircularProgress, Grid, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';
import moment from 'moment';
import InformativeCard from '../InformativeCard';
import clipboard from '../../../../assets/images/clipboard.png';
import CustomDialog from '../../../../components/CustomDialog';
import CustomDataTable from '../../../../components/CustomDataTable';
import { useFeedback } from '../../../../hooks/feedback';
import { CondominiumReducerData } from '../../../../store/reducers/condominiumReducer';
import { AppState } from '../../../../store';
import {
  subtract,
  toDefaultServerDateFormat,
} from '../../../../utils/date.util';
import { findExtraHourRanking } from '../../../../services/personnelDepartment.service';
import { RegisterRankingDTO } from '../../../../models/dto/RegisterRankingDTO';

const ExceedOvertimeCard: React.FC = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [registerRanking, setRegisterRanking] = useState<RegisterRankingDTO[]>(
    [],
  );
  const { addFeedback } = useFeedback();
  const { condominiumSelected }: CondominiumReducerData = useSelector(
    (state: AppState) => state.condominiumReducer,
  );

  const handleCardClick = useCallback(async () => {
    try {
      const reference = condominiumSelected?.referencia;
      if (reference) {
        setRegisterRanking([]);
        setOpenDialog(true);
        setLoading(true);
        const today = moment().toDate();
        const todayFormatted = toDefaultServerDateFormat(today);
        const aMonthAgo = toDefaultServerDateFormat(
          subtract(today, 1, 'month'),
        );

        const { data } = await findExtraHourRanking(
          reference,
          aMonthAgo,
          todayFormatted,
        );
        setRegisterRanking(data?.flatMap(item => item));
      }
    } catch (error) {
      addFeedback({
        type: 'error',
        description: 'Ocorreu um erro ao buscar as informações.',
      });
    } finally {
      setLoading(false);
    }
  }, [addFeedback, condominiumSelected]);

  const columns = [
    {
      name: 'numCad',
      label: 'Matrícula',
    },
    {
      name: 'nomeFuncionario',
      label: 'Nome do Colaborador',
    },
    {
      name: 'cargo',
      label: 'Função',
    },
    {
      name: 'dataApuracao',
      label: 'Data',
    },
    {
      name: 'totalHorasExtras',
      label: 'Total',
    },
  ];

  return (
    <>
      <InformativeCard
        imgAltText="Horas extras"
        imgSrc={clipboard}
        cardTitle="Funcionários com mais de 2h extras por período"
        cardText="Saiba quantos funcionários estão registrados com horas extras superior a 2 horas."
        handleCardClick={handleCardClick}
      />
      <CustomDialog
        open={openDialog}
        handleClose={() => setOpenDialog(false)}
        handleConfirm={() => setOpenDialog(false)}
        showOneButton
        maxWidth="md"
        okButtonLabel="Fechar"
        showCloseButton
      >
        <CustomDataTable
          title={
            <Grid container direction="row">
              <Typography variant="h6">
                Funcionários com mais de 2h extras por período
              </Typography>
              {loading && (
                <CircularProgress
                  size={20}
                  style={{ marginLeft: 15, position: 'relative', top: 4 }}
                />
              )}
            </Grid>
          }
          data={registerRanking}
          columns={columns}
          options={{ elevation: 0, download: true }}
        />
      </CustomDialog>
    </>
  );
};

export default ExceedOvertimeCard;
